import React, { FC } from 'react';
import {Div} from './styles'

type BackdropProps = {
  children: React.ReactNode;
  moveUp?: boolean;
  className?: string;
};

const Backdrop: FC<BackdropProps> = (props: BackdropProps) => {
  return (
    <Div className={props.className} moveUp={props.moveUp}>
      {props.children}
    </Div>
  );
}

export default Backdrop
